import { ActionKeys } from '~/actions/constants';
import * as featureTestsActions from '~/actions/feature-tests.actions';
import { GTMEventPayload, sendGTMEvent } from '~/actions/gtm.actions';
import { AxiosResponse } from 'axios';
import { FEATURE_TESTS_PUSHED_EVENT } from '~/constants/gtm';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getAllFeatureTestVariantNames } from '~/selectors/features.selectors';
import * as featureTestService from '~/services/feature-tests.service';
import {
  featureTestUserVariantFromJSON,
  featureTestVariantFromJSON,
  JSONFeatureTestUserVariant,
  JSONFeatureTestVariant,
} from '~/types/FeatureTest';
import { selectState } from '..';

export function* initializeFeatureTestVariantNames() {
  const names: ReturnType<typeof getAllFeatureTestVariantNames> = yield selectState<
    ReturnType<typeof getAllFeatureTestVariantNames>
  >(getAllFeatureTestVariantNames);
  if (names) {
    const gtmEvent: GTMEventPayload = {
      eventName: FEATURE_TESTS_PUSHED_EVENT,
      data: {
        featureTestVariants: names.join(', '),
      },
    };
    yield put(sendGTMEvent(gtmEvent));
  }
}

export function* fetchFeatureTests() {
  try {
    const response: AxiosResponse<{ results: JSONFeatureTestUserVariant[] }> = yield call(
      featureTestService.fetchFeatureTests,
    );
    yield put(
      featureTestsActions.fetchFeatureTestSuccess(
        response.data.results.map(featureTestUserVariantFromJSON),
      ),
    );
  } catch (err) {
    // Continue with error.
  }
}

export function* rollFeatureTestDice(
  action: ReturnType<typeof featureTestsActions.rollFeatureTestDice>,
) {
  try {
    const { featureTestName } = action.payload;
    const response: AxiosResponse<JSONFeatureTestVariant> = yield call(
      featureTestService.rollDice,
      featureTestName,
    );
    const featureTestUserVariant = {
      featureTest: {
        name: featureTestName,
      },
      featureTestVariant: {
        ...featureTestVariantFromJSON(response.data),
      },
    };
    yield put(featureTestsActions.rollTestFeatureDiceSuccess(featureTestUserVariant));
  } catch (err) {
    // Continue with error.
  }
}

export function* assignFeatureTestVariant(
  action: ReturnType<typeof featureTestsActions.assignFeatureTestVariant>,
) {
  try {
    const { featureTestName, variantName } = action.payload;
    const response: AxiosResponse<JSONFeatureTestVariant> = yield call(
      featureTestService.assignTestVariant,
      featureTestName,
      variantName,
    );
    const featureTestUserVariant = {
      featureTest: {
        name: featureTestName,
      },
      featureTestVariant: {
        ...featureTestVariantFromJSON(response.data),
      },
    };
    yield put(featureTestsActions.assignFeatureTestVariantSuccess(featureTestUserVariant));
  } catch (e) {
    yield put(featureTestsActions.assignFeatureTestVariantError());
  }
}

function* postFeatureTestFetchSuccessHook() {
  yield put(featureTestsActions.initializeFeatureTestVariantNames());
}

export default [
  takeLatest(ActionKeys.FETCH_AB_TEST_FEATURES, fetchFeatureTests),
  takeLatest(ActionKeys.FETCH_AB_TEST_FEATURES_SUCCESS, postFeatureTestFetchSuccessHook),
  takeLatest(ActionKeys.INITIALIZE_FEATURE_TEST_VARIANT_NAMES, initializeFeatureTestVariantNames),
  takeLatest(ActionKeys.ROLL_FEATURE_TEST_DICE, rollFeatureTestDice),
  takeLatest(ActionKeys.FEATURE_TEST_ASSIGN, assignFeatureTestVariant),
];
